<script>
export default {
  name: 'ButtonGroup',
  render () {
    return <div class='re-btn-group'>{this.$slots.default}</div>
  }
}
</script>



// WEBPACK FOOTER //
// src/package/ButtonGroup/button-group.vue